// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: 'a86df9260',
  buildTime: '2026-11-03T18:40:27.546Z',
} as const;
